<template>
  <div>
    <base-header class="mt-4 pb-6" type=""></base-header>
    <b-container fluid class="mt--6">
      <div>
        <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
      </div>
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="8">
                      <h3>{{language_terms['OVERDUE_INVOICES']}}</h3>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col lg="3" md="6">
                  <base-input :label="language_terms['CUSTOMER'] + ' From'">
                    <multiselect
                        @search-change="asyncFindCustomer"
                        v-model="filter.customer_from"
                        :internalSearch = "false"
                        ref="multiselcetRef"
                        label="name"
                        track-by="id"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :preserve-search="true"
                        :options="customers"
                        :multiple="false"
                        :searchable="true"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="300"
                        :limit="50"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="false"
                        id="lookupId"
                    >
                    </multiselect>
                  </base-input>
                </b-col>
                <b-col lg="3" md="6">
                  <base-input :label="language_terms['CUSTOMER'] + ' To'">
                    <multiselect
                      :options="customers"
                      v-model="filter.customer_to"
                      @search-change="asyncFindCustomer"
                      :internalSearch = "false"
                      ref="multiselcetRef"
                      label="name"
                      track-by="id"
                      placeholder="Type to search"
                      open-direction="bottom"
                      :preserve-search="true"
                      :multiple="false"
                      :searchable="true"
                      :clear-on-select="false"
                      :close-on-select="true"
                      :options-limit="300"
                      :limit="50"
                      :limit-text="limitText"
                      :max-height="600"
                      :show-no-results="false"
                      :hide-selected="false"
                  />
                  </base-input>
                </b-col>

                <b-col lg="2" md="6">
                  <base-input :label="language_terms['SALESPERSON'] + ' From'">
                      <el-select filterable clearable v-model="filter.salesperson_from">
                        <el-option
                          v-for="item in salespersons"
                          :key="item.name"
                          :label="item.name"
                          :value="item.name"
                          >
                          </el-option>
                      </el-select>
                  </base-input>
                </b-col>

                <b-col lg="2" md="6">
                  <base-input :label="language_terms['SALESPERSON'] + ' To'">
                      <el-select filterable clearable v-model="filter.salesperson_to" >
                          <el-option
                          v-for="item in salespersons"
                          :key="item.name"
                          :label="item.name"
                          :value="item.name"
                          />
                      </el-select>
                  </base-input>
                </b-col>
                
                <b-col lg="1" md="6" >
                  <base-input :label="'Closing ' + language_terms['DATE']">
                    <flat-picker v-model="filter.date_closing" slot-scope="{focus, blur}" @on-open="focus" @on-close="blur" style="background-color: white;" class="form-control datepicker"/>
                  </base-input>
                </b-col>

                <b-col cols="1" class="mt-4">
                  <base-button type="primary" @click="onClickSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                </b-col>
              </b-row>
            </card>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="tableItems.length > 0">
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="8">
                      <h3>Sales Invoices</h3>
                  </b-col>
                </b-row>
              </div>
              <b-row class="mt--4" v-if="tableItems.length > 0">
                <b-col cols="12" class="mt-3">
                    <b-table-simple hover responsive>
                        <b-thead head-variant="light">
                            <b-th>{{language_terms['SALESPERSON']}}</b-th>
                            <b-th>{{language_terms['CREDIT_TERMS']}}</b-th>
                            <b-th>{{language_terms['DATE']}}</b-th>
                            <b-th>{{language_terms['INV_#']}}</b-th>
                            <b-th>{{language_terms['CUSTOMER_NAME']}} </b-th>
                            <b-th>{{language_terms['OVERDUE_AMOUNT']}} </b-th>
                        </b-thead>
                        <b-tbody>
                            <tr v-for="(invoice, i) in tableItems" :key="i" @click="onClickInvoice(invoice)">
                                <td>{{invoice.salesperson_name}}</td>
                                <td>{{invoice.customer_credit_term}}</td>
                                <td>{{invoice.invoice_date}}</td>
                                <td>{{invoice.invoice_number}}</td>
                                <td>{{invoice.customer_name}}</td>
                                <td>{{(invoice.overdue_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                            </tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>                            
            </card>
          </div>
        </b-col>
      </b-row>
      <b-modal id="modalInvoice" v-model="modalInvoice" size="xl" centered class="my-modal" hide-footer>
        <template>
            <div v-if="modalInvoice">
                <b-row class="align-items-center">
                    <b-col md="12" fluid class="mt--7">
                        <h6 class="h2">{{language_terms["SALE_INVOICE"]}}</h6>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="6">
                        <base-input :label="language_terms['INV_#']" :value="invoice.master.code" disabled></base-input>
                    </b-col>
                    <b-col lg="3" md="6">
                        <base-input :label="language_terms['DATE']" :value="invoice.master.date" disabled></base-input>
                    </b-col>
                    <b-col lg="3" md="6">
                        <base-input :label="language_terms['SALESPERSON']" :value="invoice.master.salesperson_name" disabled></base-input>
                    </b-col>
                    <b-col lg="3" md="6">
                        <base-input :label="language_terms['TYPE']" :value="invoice.master.type" disabled></base-input>
                    </b-col>
                    <b-col lg="12">
                        <base-input label="Remarks"><textarea disabled class="form-control" id="exampleFormControlTextarea1" rows="3" :value="invoice.master.remarks"></textarea>
                        </base-input>
                    </b-col>
                </b-row>
                <b-row v-if="invoice.details.rows.length > 0">
                    <b-col cols="12">
                        <v-client-table v-model="invoice.details.rows" :columns="invoice.details.columns" :options="reportOptions"  >
                        </v-client-table>
                    </b-col>
                </b-row>
            </div>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>
<style>
th.VueTables__sortable {color:rgb(255,255,255);}
td.VueTables__row  {color:black}
.v-data-table /deep/ .sticky-header {position: sticky; top: var(--toolbarHeight);}
.v-data-table /deep/ .v-data-table__wrapper {overflow: unset;}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import moment from 'moment'
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue'

export default {
  components:{
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
  computed:{
      ...mapState({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
      }),
    },
  async mounted()
  {
    this.loadingCounter++

    this.loadSalepersonList()

    this.loadingCounter--
  },

  data(){
    return{
      loadingCounter: 0,
      reportOptions:{perPage:10000, perPageValues:[],stickyHeader:true, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C', hiddenColumns:['id','customer_id','invoice_date','customer_code','Exch Rate'],filterable:false},
      customers:[],
      tableItems:[],
      salespersons:[],
      selectedInvoice:[],
      report:{headers:[], rows:[]},
      modalInvoice:false,
      filter:{
        customer_from: null,
        customer_to: null,
        salesperson_from:null,
        salesperson_to:null,
        date_closing:new Date(),
      },
    }
  },

  methods:{
    async onClickInvoice(invoice)
    {
        if (invoice)
        {
          let payload = {document_id:invoice.document_id}
          await axios.post(apiRoutes['CLIENT_RETRIEVE_SALES_INVOICE'],payload, authHeader()).then((response)=>
          {
            if (response.data.code == 1)
            {
                this.invoice = response.data.data
                this.modalInvoice = true
            }
            else
            {
                this.invoice = null;
            }
          }
        )
        .catch((error)=> {
          if(error.response)
          {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
        });
      }
    },
    
    limitText(count)
    {
        return `and ${count} other customers`;
    },
    async loadSalepersonList()
    {
      this.loadingCounter++

      let payload = {"role_code":"sales person"}
      await axios.post(apiRoutes["LIST_SALE_PERSOPNS"], payload, authHeader()).then((response) => {
        if (response.data.code == 1)
        {
          this.salespersons = response.data.data;
        }
        else
        {
          this.salespersons = [];
        }
          
      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});          
      }
      });        
      this.loadingCounter--
      
    },
    async asyncFindCustomer(query) 
    {
      let payload = { value: query };
      await axios.post(apiRoutes["CUSTOMER_LOOKUP"], payload, authHeader()).then((response) => {
        if (response.data.code == 1) {
          this.customers = response.data.data;
        } else {
          // this.customers = [];
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});          
      }
      });
    },
    async onClickSearch()
    {
      this.loadingCounter++

      this.filter.limit = ''
      let payload = this.filter
      if (payload.customer_from)
        payload.customer_from_name = payload.customer_from.name
      else
        payload.customer_from_name = null

      if (payload.customer_to)
        payload.customer_to_name = payload.customer_to.name
      else
        payload.customer_to_name = null
      
      await axios
      .post(apiRoutes["CLIENT_SALES_OVERDUE_QUICK_SEARCH"], payload, authHeader())
      .then((response) => 
      {
        if (response.data.code == 1) {
          this.tableItems = response.data.data
        } 
        else 
        {
          alert('Failed');
        }
      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });

      this.loadingCounter--
    },
  }
}
</script>
